/**
 * The global state selectors
 */
import { State } from "reducers";

import { createSelector } from "reselect";
import storage from "../persistance";
import { GlobalState, initialState } from "./redux";

export const selectGlobal: (arg0: State) => GlobalState = (state) =>
  state.global || initialState;

export const selectActivationCode = createSelector(
  selectGlobal,
  (substate) => substate.activationCode
);

export const selectSessionToken = createSelector(
  selectGlobal,
  (substate) => storage.getItem("SESSION_KEY") || substate.token
);

export const selectToken = createSelector(
  selectGlobal,
  (substate) => substate.token
);

export const selectUserName = createSelector(
  selectGlobal,
  (substate) => substate.userInfo.preferred_username
);

export const selectUserInfo = createSelector(
  selectGlobal,
  (substate) => substate.userInfo
);

export const selectUserDetails = createSelector(
  selectGlobal,
  (substate) => substate.userDetail
);

export const selectUserCidpId = createSelector(
  selectGlobal,
  (substate) => substate.userInfo.cidpId
);

export const selectToast = createSelector(
  selectGlobal,
  (substate) => substate.toast
);

export const selectGlobalLoading = createSelector(
  selectGlobal,
  (substate) => substate.globalLoading
);

export const selectGlobalFeatureFlags = createSelector(
  selectGlobal,
  (substate) => substate.featureFlags
);

export const selectDirectLoginEnabled = createSelector(
  selectUserDetails,
  (substate) => substate.directLoginEnabled
);

export const selectTnCForCidpUser = createSelector(
  selectGlobal,
  (substate) => substate.tncForCidpUser
);

export const selectHasUserAcceptedTnC = createSelector(
  selectGlobal,
  (substate) => substate.hasUserAcceptedTnC
);

export const selectLoadingCheckOnUpdatedTnC = createSelector(
  selectGlobal,
  (substate) => substate.loadingCheckOnUpdatedTnC
);

export const selectLoadingTnC = createSelector(
  selectGlobal,
  (substate) => substate.loadingTnC
);
